var styles = {"box":"Tabs_box_mpyem_1","box__inner":"Tabs_box__inner_mpyem_23","swiper-shadow":"Tabs_swiper-shadow_mpyem_32","button":"Tabs_button_mpyem_43","swiper":"Tabs_swiper_mpyem_32","slide":"Tabs_slide_mpyem_67","gradient-btn":"Tabs_gradient-btn_mpyem_74","active":"Tabs_active_mpyem_77","v2":"Tabs_v2_mpyem_86"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
